import React, { useState, useEffect, useRef } from "react";
import "../styles/Clause.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";

export default function Clause({ Clause }) {
  const [isHotSpotOpen, setisHotSpotOpen] = useState(false);

  const handleHotSpotCard = (e) => {
    setisHotSpotOpen(!isHotSpotOpen);
  };

  let buttonRef = useRef();

  useEffect(() => {
    let handler = (e) => {
      if (isHotSpotOpen === true && !buttonRef.current.contains(e.target)) {
        setisHotSpotOpen(false);
      }
      if (isHotSpotOpen === false) {
      }
    };

    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [isHotSpotOpen]);

  return (
    <div className="w-full min-w-0 max-w-full">
      <div
        className={`relative w-full min-w-0 max-w-full${isHotSpotOpen ? " clause-hotspot-anchor" : ""}`}
        ref={buttonRef}
      >
        {isHotSpotOpen === true ? (
          <div className="flex items-center clause-row">
            <FontAwesomeIcon
              icon={faMinus}
              color="#cc0000"
              onClick={handleHotSpotCard}
              className="clause-icon-minus pt-1"
            />
            <div className="flex items-center pl-2 pt-1 clause-font">
              {Clause.title}
            </div>
          </div>
        ) : (
          <div className="flex items-center clause-row">
            <FontAwesomeIcon
              icon={faPlus}
              color="#1b489b"
              onClick={handleHotSpotCard}
              className="clause-icon-plus pt-1"
            />
            <div className="flex items-center pl-2 pt-1 clause-font">
              {Clause.title}
            </div>
          </div>
        )}

        <div className="clause-popup-slot">
          {isHotSpotOpen === true ? (
            <>
              <div className="absolute button-window ">
                <div
                  dangerouslySetInnerHTML={{
                    __html: Clause.notes,
                  }}
                />
                {Clause.text.length === 0 ? (
                  ""
                ) : (
                  <>
                    {" "}
                    <br />
                  </>
                )}

                <div
                  dangerouslySetInnerHTML={{
                    __html: Clause.text,
                  }}
                />
                <br />
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}

/*<button className="copy-clause">Copy Clause</button>

<>
                    <button>
                      <FontAwesomeIcon
                        icon={faCopy}
                        size="lg"
                        className="copy-icon"
                      />
                      &nbsp; <strong>Copy Clause</strong>
                    </button>
                    <button className="copy-clause">Copy Clause</button>
                  </>

*/
